<template lang="pug">
div(fill-height)
  v-card.ma-4
    v-card-title Car model
    CarModelSelector(:selectedCar="car" :models="models" :driver="driver" @updateSelected="updateSelected")
  v-card.ma-4
    v-card-title Driver Profile
    v-card-text
      v-card-subtitle Current battery level
      v-slider(
        v-model="driver.battery",
        :min="10",
        :max="100",
        @change="updateTrip"
      )
        template(v-slot:append)
          span {{ batteryPercentValue }}
      v-card-subtitle On NZ highways, how fast do you usually drive?
      p.disclaimer (This information is not saved or shared in any way. It is only used for improving your energy calculations)
      v-slider(
        v-model="driver.sa",
        :min="-50",
        :max="50",
        @change="updateTrip"
      )
        template(v-slot:append)
          span {{ sakmhValue }}
      v-card-subtitle At intersections and on corners...<br>How much of a lead foot do you have?
      p.disclaimer (Again, this is kept private. 50% is the average)
      v-slider(v-model="driver.aa", :min="0", :max="100", @change="updateTrip")
        template(v-slot:append)
          span {{ aaPercentValue }}
  v-row
    v-col.right
      v-btn.mx-4(color="primary", @click="$emit('next')") Next
  v-expansion-panels
    v-expansion-panel
      v-expansion-panel-header.text-h6 Advanced Options
      v-expansion-panel-content 
        v-card-text
          v-card-subtitle What is the battery health?
          v-slider(
            v-model="driver.soh",
            :min="10",
            :max="100",
            @change="updateTrip"
          )
            template(v-slot:append)
              span {{ sohPercentValue }}
          v-card-subtitle Number of passengers
          v-slider(
            v-model="driver.passengers",
            :min="0",
            :max="8",
            @change="updateTrip"
          )
            template(v-slot:append)
              span {{ driver.passengers }}
          v-card-subtitle Charge battery %
          v-range-slider(v-model="range", :max="100", @change="updateTrip")
            template(v-slot:prepend)
              v-text-field(
                :value="range[0]",
                @change="$set(range, 0, $event)",
                prefix="Min",
                suffix="%"
              )
            template(v-slot:append)
              v-text-field(
                :value="range[1]",
                @change="$set(range, 1, $event)",
                prefix="Max",
                suffix="%"
              )
          v-card-subtitle Add extra weight?
          v-slider(
            v-model="driver.extraWeight",
            :min="0",
            :max="1500",
            @change="updateTrip"
          )
            template(v-slot:append)
              span {{ extraWeightKG }}
</template>

<script>
import CarModelSelector from "../components/CarModelSelector.vue";
export default {
  components: { CarModelSelector },
  props: ["models", "driver", "selectedCar"],
  data() {
    return {
      car: this.selectedCar,
      year: 2018,
      activeID: 0,
      range: [this.driver.batteryMin, this.driver.batteryMax],
    };
  },
  computed: {
    aaPercentValue() {
      return this.driver.aa + "%";
    },
    sohPercentValue() {
      return this.driver.soh + "%";
    },
    sakmhValue() {
      return this.driver.sa + 100 + "kph";
    },
    saPercentValue() {
      return this.driver.sa + "%";
    },
    batteryPercentValue() {
      return this.driver.battery + "%";
    },
    batteryMaxPercentValue() {
      return this.driver.batteryMax + "%";
    },
    batteryMinPercentValue() {
      return this.driver.batteryMin + "%";
    },
    extraWeightKG() {
      return this.driver.extraWeight + " kg";
    },
    extraWeight() {
      return this.driver.extraWeight;
    },
  },
  methods: {
    newProfile() {
      //save stuff here:
      var obj = {};

      obj.batterySize = this.car.BatterySize;
      obj.carSpecificationID = this.car.ID;
      obj.chainPerformanceTraction = this.car.ChainPerformanceTraction;
      obj.crr = this.car.CRR;
      obj.currentCharge = this.driver.battery / 100;
      obj.dragCoefficient = this.car.DragCoefficient;
      obj.drivingStyle = this.driver.aa / 10;
      obj.equivilentFuelEfficiency = this.car.EquivilentFuelEfficiency;
      obj.extraWeight = this.driver.extraWeight;
      obj.hybrid = this.car.Hybrid;
      obj.make = this.car.Make;
      obj.maxAC = this.driver.batteryMax;
      obj.maxCharge = this.driver.batteryMax;
      obj.maxDC = this.driver.batteryMax;
      obj.maxRange = this.driver.MaxRange;
      obj.maxSpeed = this.driver.MaxSpeed;
      obj.minCharge = this.driver.batteryMin;
      obj.model = this.car.Model;
      obj.name = this.car.Name;
      obj.numberOfPassengers = this.driver.passengers;
      obj.plugsList = this.car.PlugsList;
      obj.recoveryMax = this.car.RecoveryMax;
      obj.savedName = "My " + this.car.Name;
      obj.showRange = 0;
      obj.speed = this.driver.sa;
      obj.stateOfHealth = this.driver.soh / 100;
      obj.weight = this.car.Weight;
      obj.year = this.year;
      this.$user.driverProfiles.push(obj);
      this.carMode = "garageMode";
      this.car = obj;
    },
    updateSelected(car) {
      this.car = car;
      this.$emit("updateSelected", this.car);
    },
    updateTrip() {
      this.$emit("updateTrip");
    },
    updateSoh() {
      if (this.year > 2000) {
        let soh = (1 - (new Date().getFullYear() - this.year) * 0.03) * 100;
        if (this.car.Soh) {
          soh = this.car.Soh;
        } else if (this.car.stateOfHealth) {
          soh = this.car.stateOfHealth * 100;
        }
        this.driver.soh = soh;
      }
    },
  },
  watch: {
    range: function (val) {
      console.log(val);
      this.driver.batteryMin = val[0];
      this.driver.batteryMax = val[1];
      if (this.activeID) {
        this.updateProfile(this.activeID);
      }
    },
    car: function (val) {
      if (val.Year) {
        this.year = val.Year;
      }
      this.updateSoh();
      if (this.activeID) {
        this.updateProfile(this.activeID);
      }
    },
    year: function (val) {
      this.year = val;
      this.updateSoh();
      this.updateProfile(this.activeID);
    },
    extraWeight: function (val) {
      this.driver.extraWeight = val;
      this.updateProfile(this.activeID);
    },
  },
};
</script>

<style scoped>
.v-card__subtitle {
  text-align: center;
}

.disclaimer {
  font-style: italic;
  text-align: center;
  width: 60%;
  margin: auto;
}
.right {
  text-align: right;
}
</style>
